export default __webpack_public_path__ + "static/media/illustration-study-1-w@3x.10d0eb84.png";